<template>
    <div id="about">
        <div class="container py-4">
            <p class="h1 text-dark">Our Mission</p>
            <div class="container bg-light border border-dark rounded">
                <div class="row">
                    <div class="col-12 col-md-6 text-left p-4 border-right">
                        <p class="h2 text-dark">
                            Novel Immunotherapeutics for Cancer and Viruses
                        </p>
                        <p class="lead text-dark d-block">
                            Bispecific Antibody: We have developed bispecific
                            antibodies to target Glioblastoma Cancer Stem Cells
                            that are EGFRvIII+/CD133<sup>+</sup>.
                        </p>
                        <p class="lead text-dark d-block">
                            Peptide Vaccine Therapy for Glioblastoma: We
                            discovered and developed the first peptide vaccine
                            based on EGFRvIII, Rindopepimut, which was tested in
                            multiple Phase II studies and an international Phase
                            III trial.
                        </p>
                        <p class="lead text-dark d-block">
                            <!-- We are leveraging what we learned about identifying
                            HLA class 1 Binding peptides that induce CD8<sup
                                >+</sup
                            >
                            T cell response against SARS-CoV-2 -->
                            Next Generation Cancer and Anti-Viral Vaccines: We
                            are leveraging our recently developed technologies
                            for identifying HLA class I binding peptides to
                            induce CD8<sup>+</sup> T cell responses against mutant cancer
                            proteins and viral proteins from SARS-CoV-2.
                        </p>
                    </div>
                    <div class="col-12 col-md-6 border-left p-4">
                        <div
                            id="carouselExampleIndicators"
                            class="carousel slide mx-auto"
                            data-ride="carousel"
                        >
                            <ol class="carousel-indicators">
                                <li
                                    data-target="#carouselExampleIndicators"
                                    data-slide-to="0"
                                    class="active"
                                ></li>
                                <li
                                    data-target="#carouselExampleIndicators"
                                    data-slide-to="1"
                                ></li>
                                <li
                                    data-target="#carouselExampleIndicators"
                                    data-slide-to="2"
                                ></li>
                            </ol>
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <img
                                        class="d-block w-100 about-img"
                                        src="../img/BispecificAntibod.jpg"
                                        alt="First slide"
                                    />
                                    <div
                                        class="
                                            carousel-caption
                                            d-none d-md-block
                                            caption
                                        "
                                    >
                                        <!-- <h5>Header A</h5>
                                        <p>Paragraph A</p> -->
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <img
                                        class="d-block w-100 about-img"
                                        src="../img/T_cell_receptor.png"
                                        alt="Second slide"
                                    />
                                    <div
                                        class="
                                            carousel-caption
                                            d-none d-md-block
                                            caption
                                        "
                                    >
                                        <!-- <h5>Header B</h5>
                                        <p>Paragraph B</p> -->
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <img
                                        class="d-block w-100 about-img"
                                        src="../img/T_cell.png"
                                        alt="Third slide"
                                    />
                                    <div
                                        class="
                                            carousel-caption
                                            d-none d-md-block
                                            caption
                                        "
                                    >
                                        <!-- <h5>Header C</h5>
                                        <p>Paragraph C</p> -->
                                    </div>
                                </div>
                            </div>
                            <a
                                class="carousel-control-prev"
                                href="#carouselExampleIndicators"
                                role="button"
                                data-slide="prev"
                            >
                                <span
                                    class="carousel-control-prev-icon"
                                    aria-hidden="true"
                                ></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a
                                class="carousel-control-next"
                                href="#carouselExampleIndicators"
                                role="button"
                                data-slide="next"
                            >
                                <span
                                    class="carousel-control-next-icon"
                                    aria-hidden="true"
                                ></span>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "About",
    data() {
        return {
            activeId: 0,
        };
    },

    mounted() {},
};
</script>

<style scoped>
.scrollspy {
    position: relative;
}

.about-img {
    /* background-image: url('../img/sid_beach.jpg'); */
    width: 100%;
    height: 300px;
    background-size: cover;
}

.caption {
}
</style>